import React from 'react';
import { PageSection } from '../PageSection';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { PRODUCT_NAME, finalStages } from '../../data/salesContent';
export function FinalCtaSection() {
  return <PageSection labelledBy="final-offer-title" className="bg-slate-950" data-id="element-101" data-mp="2ditugignm3pj">
      <div className="rounded-3xl border-2 border-cyan-500 bg-zinc-950 p-6 text-center md:p-10" data-id="element-102" data-mp="2dlpr83grmmce">
        <ProductImage className="mx-auto w-full max-w-md" data-id="element-103" data-mp="2rgrv6l21y1mk" />
        <h2 id="final-offer-title" className="mt-6 font-display text-2xl font-extrabold uppercase leading-tight text-white md:text-[2rem]" data-id="element-104" data-mp="2mj9vll9xcyr8">
          {PRODUCT_NAME}
        </h2>
        <p className="mt-2 text-base font-semibold uppercase text-zinc-300" data-id="element-105" data-mp="2w9kzx8xit9yn">El sistema visual completo para el conductor</p>
        <p className="mx-auto mt-4 max-w-lg font-display text-xs font-extrabold uppercase leading-relaxed tracking-wide text-cyan-400 md:text-sm" data-id="element-106" data-mp="3aa5ic3zix3rm">
          {finalStages.join(' • ')}
        </p>
        <PriceBlock className="mt-7" data-id="element-107" data-mp="221w2vmbb2aaw" />
        <div className="mt-7" data-id="element-108" data-mp="222xhu1vfzgxw">
          <CtaButton note="Acceso inmediato · Entrega digital" data-id="element-109" data-mp="261ednp9ex500">Quiero acceder al sistema completo</CtaButton>
        </div>
      </div>
    </PageSection>;
}